import React, { useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useGlobalState } from "../../contexts/GlobalContext";
import { Http, Routes } from "../../utils/constants";
import {
  createSSOBasicUser,
  checkEmailExists,
  updateUserMetadata,
} from "../../utils/helpers/api";
import { AxiosResponse } from "axios";

const ConfirmRegister: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { setStateValue, globalState, setGlobalState } = useGlobalState();

  useEffect(() => {
    if (
      location.pathname !== Routes.CONFIRM_REGISTER &&
      location.pathname !== Routes.REGISTER
    ) {
      sessionStorage.removeItem("formData");
    }
  }, [location.pathname]);

  useEffect(() => {
    const handleUnload = () => {
      sessionStorage.removeItem("formData");
    };

    window.addEventListener("beforeunload", handleUnload);
    return () => {
      window.removeEventListener("beforeunload", handleUnload);
    };
  }, []);

  const handleSendEmail = async () => {
    setStateValue("loader", true);
    const {
      state: { email, password },
    } = location;
    try {
      const result = (await createSSOBasicUser(
        email,
        password,
      )) as AxiosResponse;
      if (result?.status === Http.SUCCESS_CODE) {
        // fetchCreateSSOBasicUser(email, password);
        // navigate(Routes.EMAIL_SENT, { state: { email, password } });
        sessionStorage.removeItem("formData");
        const loginCallBackUrl = localStorage.getItem("loginCallBackUrl");
        const raw = localStorage.getItem("transition_source");
        let transitionSourceValue = null; 
        let currentUserId = null;
        if (raw) {
          try {
            const parsed = JSON.parse(raw);
            if (parsed && typeof parsed === "object" && "value" in parsed) {
              transitionSourceValue = parsed.value;
            } else {
              transitionSourceValue = raw;
            }
          } catch {
            transitionSourceValue = raw;
          }
        }
        const response = (await checkEmailExists(
          email ?? ""
        )) as AxiosResponse;
        if (response && response.data.user) {
          const { user_id, user_metadata } = response.data.user;
          currentUserId = user_id;
          if (!loginCallBackUrl) {
            const dataUpdate: IUserMetaDataApi = user_metadata ?? {};
            if (transitionSourceValue === "kankyobusiness") {
              dataUpdate.transition_source = "kankyobusiness";
              const expireAt = new Date();
              expireAt.setDate(expireAt.getDate() + 30);
              localStorage.setItem(
                "transition_source",
                JSON.stringify({
                  value: "kankyobusiness",
                  expireAt: expireAt.toISOString(),
                })
              );
            }
            dataUpdate.user_status = 3;
            dataUpdate.authenticated = 0;

            setGlobalState({
              ...globalState,
              user: {
                ...globalState.user,
                user_metadata: {
                  ...dataUpdate
                }
              }
            });

            await updateUserMetadata(email, user_id, dataUpdate)
          } else {
            if (transitionSourceValue === "kankyobusiness") {
              const dataUpdate: IUserMetaDataApi = user_metadata ?? {};
              dataUpdate.transition_source = "kankyobusiness";
              const expireAt = new Date();
              expireAt.setDate(expireAt.getDate() + 30);
              localStorage.setItem(
                "transition_source",
                JSON.stringify({
                  value: "kankyobusiness",
                  expireAt: expireAt.toISOString(),
                })
              );
              await updateUserMetadata(email, user_id, dataUpdate)
            }
          }
        }
        navigate(Routes.EMAIL_SENT, { 
          state: { 
            email, 
            password, 
            user_id: currentUserId 
          } 
        });
      }
    } catch (err) {
      if (!(err instanceof Error)) {
        const result = err as AxiosResponse;
        if (result.status === Http.ERROR_EMAIL_CONFLICT) {
          checkEmailExists(email ?? "", true)
          navigate(Routes.EMAIL_SENT, { state: { email, password } });
        }
        return result;
      }
    } finally {
      setStateValue("loader", false);
    }
  };

  return (
    <div className="register-page confirm-step">
      <section>
        <div className="rp-head">
          <div className="step-info">
            <div className="content">
              <div className="page-title">
                {/* <span>
                  <img src="/images/register/Indicator2.png" alt="" />
                </span> */}
                <span>メールアドレス確認</span>
              </div>
              <p className="description">
                {location.state?.email}{" "}
                に確認メールを送信します。よろしければ「送信」ボタンを押してください。
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="register-form">
        <div>
          <div className="buttons ">
            <Link to={Routes.REGISTER} className="btn-back">
              <span>戻る</span>
            </Link>
            <button onClick={handleSendEmail} className="btn-submit">
              <span>送信</span>
            </button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ConfirmRegister;
